<!-- Chips strip: the offline label and attachment chips, rendered above the input row -->
<div class="mic-input__chips" *ngIf="isOffline || attachments.length">
  <span class="mic-input__chip mic-input__chip--offline" *ngIf="isOffline" role="status">
    <ion-icon name="cloud-offline-outline" aria-hidden="true"></ion-icon>
    {{ offlineLabel }}
  </span>
  <span class="mic-input__chip" *ngFor="let a of attachments; trackBy: trackByKindId">
    <ion-icon [name]="a.kind === 'meeting' ? 'sparkles-outline' : a.kind === 'transcript' ? 'document-text-outline' : a.kind === 'account' ? 'business-outline' : a.kind === 'spotlight' ? 'compass-outline' : 'person-circle-outline'"></ion-icon>
    {{ a.label }}
    <button type="button" class="mic-input__chip-remove" (click)="removeAttachment.emit(a)" [attr.aria-label]="'NOVA_REMOVE_ATTACHMENT' | translate: { label: a.label }"><ion-icon name="close"></ion-icon></button>
  </span>
</div>
<!-- `/` command menu — skills bound to the assistant agent, filtered by the typed token -->
<div class="mic-input__slash" *ngIf="slashOpen" role="listbox" [attr.aria-label]="'NOVA_SKILLS' | translate">
  <button
    *ngFor="let s of slashResults; let i = index; trackBy: trackBySkillId"
    type="button"
    class="mic-input__slash-row"
    [class.mic-input__slash-row--active]="i === slashIndex"
    role="option"
    [attr.aria-selected]="i === slashIndex"
    [attr.title]="s.description"
    (mouseenter)="slashIndex = i"
    (click)="pickSkill(s)">
    <span class="mic-input__slash-cmd">/{{ s.command }}</span>
    <span class="mic-input__slash-desc" *ngIf="s.description">{{ s.description }}</span>
  </button>
  <p class="mic-input__slash-empty" *ngIf="!slashResults.length">{{ 'NOVA_NO_SKILLS' | translate }}</p>
</div>
<!-- Single row: mic/stop on LEFT | input field | send/cancel on RIGHT -->
<div class="mic-input" [class.mic-input--listening]="state === 'listening'">
  <!-- LEFT: mic (idle) or pulsating stop (listening) -->
  <button
    *ngIf="state === 'idle'"
    type="button"
    class="mic-input__attach"
    [attr.aria-label]="'NOVA_ATTACH_CONTEXT' | translate"
    [title]="'NOVA_ATTACH_CONTEXT_HINT' | translate"
    [disabled]="isSending || isOffline"
    (click)="attachClick.emit()">
    <ion-icon name="at-outline" aria-hidden="true"></ion-icon>
  </button>
  <button
    *ngIf="state === 'idle' && micAvailable"
    type="button"
    class="mic-input__mic"
    [attr.aria-label]="'NOVA_START_VOICE_INPUT' | translate"
    [title]="(isSending ? 'NOVA_WAIT_FOR_REPLY' : 'NOVA_TAP_TO_SPEAK') | translate"
    [disabled]="isSending"
    (click)="startListening()">
    <ion-icon name="mic-outline" aria-hidden="true"></ion-icon>
  </button>
  <button
    *ngIf="state === 'listening'"
    type="button"
    class="mic-input__stop"
    [attr.aria-label]="'NOVA_STOP_VOICE_INPUT' | translate"
    [title]="'NOVA_STOP_LISTENING' | translate"
    (click)="stopListening()">
    <span class="mic-input__stop-ring" aria-hidden="true"></span>
    <span class="mic-input__stop-ring mic-input__stop-ring--lag" aria-hidden="true"></span>
    <ion-icon name="stop" aria-hidden="true"></ion-icon>
  </button>

  <!-- Text field — shows the live transcription stream while listening -->
  <input
    #inputEl
    class="mic-input__field"
    type="text"
    [(ngModel)]="draft"
    (ngModelChange)="onDraftChange($event)"
    name="draft"
    [placeholder]="state === 'listening' ? ('NOVA_LISTENING_PLACEHOLDER' | translate) : fieldPlaceholder"
    [disabled]="isSending"
    [readonly]="state === 'listening'"
    autocomplete="off"
    (keydown)="onKeydown($event)"
    (keyup.enter)="state === 'idle' && submit()"
    (keyup.escape)="state === 'listening' && cancelListening()" />

  <!-- RIGHT: when listening — duration + cancel; when idle — send -->
  <span *ngIf="state === 'listening'" class="mic-input__duration" aria-hidden="true">{{ durationLabel }}</span>
  <button
    *ngIf="state === 'listening'"
    type="button"
    class="mic-input__cancel"
    [attr.aria-label]="'NOVA_DISCARD_VOICE_INPUT' | translate"
    [title]="'DISCARD' | translate"
    (click)="cancelListening()">
    <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
  </button>
  <button
    *ngIf="state === 'idle'"
    type="button"
    class="mic-input__send"
    [disabled]="!draft.trim() || isSending || isOffline"
    (click)="submit()"
    [attr.aria-label]="'NOVA_SEND_MESSAGE' | translate">
    <ion-icon name="send" aria-hidden="true"></ion-icon>
  </button>
</div>
